import type { AuthSession } from '@ngsos/portal-core';

const AUTHENTICATION_ROUTE_PREFIX = '/authentication/';
const RENEWAL_BUDGET_BEFORE_RENDERING_ANYWAY_MS = 3_000;

export async function restoreExpiredSessionBeforeFirstRender(
  authSession: AuthSession,
): Promise<void> {
  if (window.location.pathname.startsWith(AUTHENTICATION_ROUTE_PREFIX)) {
    return;
  }

  const renewal = authSession.getAccessToken().catch(() => null);
  const budget = new Promise<null>((resolve) => {
    setTimeout(() => resolve(null), RENEWAL_BUDGET_BEFORE_RENDERING_ANYWAY_MS);
  });

  await Promise.race([renewal, budget]);
}
